import "./style.css";
import { AiFillGithub } from "react-icons/ai";
import { useLanguage } from "../../context/LanguageContext";

const projectLinks = [
  {
    demo: "https://mern-app-pxi3.onrender.com",
    github: "https://github.com/berkanankal/memories-app",
    image: require("../../assets/images/portfolio/memories-app.png"),
  },
  {
    demo: "https://netflix-clone-berkanankal.vercel.app",
    github: "https://github.com/berkanankal/netflix-clone",
    image: require("../../assets/images/portfolio/netflix-clone.png"),
  },
  {
    demo: "https://uni-x.onrender.com/",
    github: "https://github.com/berkanankal/uni-X",
    image: require("../../assets/images/portfolio/uni-x.png"),
  },
];

const Portfolio = () => {
  const { t } = useLanguage();
  const projects = t("portfolio.projects");

  return (
    <section id="portfolio">
      <div className="row section-intro">
        <div className="col-twelve">
          <h5>{t("portfolio.title")}</h5>
          <h1>{t("portfolio.subtitle")}</h1>
        </div>
      </div>

      <div className="row">
        <div className="projects">
          {projects.map((project, index) => (
            <div className="card" key={index}>
              <img
                className="card-img"
                src={projectLinks[index].image}
                alt="project"
              />
              <div className="card-content">
                <h3 className="card-title">{project.title}</h3>
                <p className="card-text">
                  {project.description}
                  {index < 2 && (
                    <>
                      <br />
                      <br />
                    </>
                  )}
                </p>
                <div className="card-links">
                  <a
                    href={projectLinks[index].demo}
                    target="_blank"
                    rel="noreferrer"
                    className="demo-btn"
                  >
                    {t("portfolio.liveDemo")}
                  </a>
                  <a
                    href={projectLinks[index].github}
                    target="_blank"
                    rel="noreferrer"
                    className="github-btn"
                  >
                    {t("portfolio.github")}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="row all-projects-btn">
        <a
          href="https://github.com/berkanankal"
          target="_blank"
          rel="noreferrer"
        >
          <AiFillGithub size={30} />
          {t("portfolio.seeAllProjects")}
        </a>
      </div>
    </section>
  );
};

export default Portfolio;
